const controllers = {
    SERVICE_ROUTES: null,
    ALLOWED_ACTIONS: null,
    ADMIN_CLIENTS_LIST:null,
    ADMIN_PROPERTIES_LIST:null
}

export default controllers